import React from 'react';
import BlockSelection from "./BlockSelection";
import Icon from "../../Icon";

const ChooseGender = [
    {icon: "venus", description: "femme", gender: 2},
    {icon: "mars", description: "homme", gender: 1},
    {icon: "venus-mars", description: "couple", gender: 3},
    {icon: "venus-double", description: "couple lesbien", gender: 4},
    {icon: "mars-double", description: "couple gay", gender: 5},
    {icon: "transgender", description: "trav / trans", gender: 6},
];

class AskSex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMoreSex: false,
        }
    }

    render() {
        return (
            <div id={"askSex"} className={"column"}>
                {this.props.isError ? <span className={"text-danger text-align-center"}>Information obligatoire</span> : null}
                <div className={"row gender-container"}>
                    {ChooseGender.slice(0, 3).map((item, index) => (
                        <BlockSelection key={index} description={item.description} gender={item.gender}
                                        isActive={this.props.gender === item.gender}
                                        onClick={() => this.props.handleBlockSelection(item.gender, "gender")}>
                            <Icon type={item.icon}/>
                        </BlockSelection>
                    ))}
                </div>
                {this.state.showMoreSex && (
                    <div className={"row gender-container"}>
                        {ChooseGender.slice(3, 6).map((item, index) => (
                            <BlockSelection key={index} description={item.description} gender={item.gender}
                                            isActive={this.props.gender === item.gender}
                                            onClick={() => this.props.handleBlockSelection(item.gender, "gender")}>
                                <Icon type={item.icon}/>
                            </BlockSelection>
                        ))}
                    </div>
                )}
                {!this.state.showMoreSex && (
                    <span className={"show-more-sex"} onClick={() => this.setState({showMoreSex: true})}><Icon
                        type={"plus-circle"}/> Plus de choix</span>)}
            </div>
        )
    }
}

export default AskSex;